import React, { useState, useEffect, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import UserService from "../../controller/UserController/UserController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import CreateUser from './CreateUser';
import RoleService from "../../controller/RoleController/RoleController";
import TeamService from "../../controller/TeamController/TeamController";
import HelpSite from "../../../Common/HelpLink";
import $ from 'jquery';
import 'datatables.net-bs5';
import 'datatables.net-bs5/css/dataTables.bootstrap5.min.css';
import Swal from 'sweetalert2';
import axios from "axios";
import BASE_URL from "../../../../config/config";
import Cookies from "js-cookie";
function UserListPage() {
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [roles, setRoles] = useState([]);
    const [teams, setTeams] = useState([]);
    const [currentUser, setCurrentUser] = useState(null);
    const { theme } = useContext(ThemeContext);
    const accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";
    const AllowedUsers = localStorage.getItem('AllowedUsers');
    const [modalInstance, setModalInstance] = useState(null);

    const [currentPage, setCurrentPage] = useState(1); // Current page
    const UserID = localStorage.getItem("UserID");
    const CompanyID = localStorage.getItem("CompanyID");

    const [totalPages, setTotalPages] = useState(1); // Total number of pages
    const [searchQuery, setSearchQuery] = useState('');
    const [poCount, setPOCount] = useState(0);
    const getPageSizeFromCookie = () => {
        const match = document.cookie.match(new RegExp('(^| )pageSize=([^;]+)'));
        return match ? parseInt(match[2], 10) : 10; // Default to 10 if no cookie is found
    };
    const setPageSizeInCookie = (pageSize) => {
        document.cookie = `pageSize=${pageSize};path=/;max-age=31536000`; // 1 year
    };
    const setSortConfigInCookie = (config) => {
        Cookies.set(`TeamSort_${CompanyID}_${UserID}`, JSON.stringify(config), { expires: 365 });
    };
    const getSortConfigFromCookie = () => {
        const sortCookie = Cookies.get(`TeamSort_${CompanyID}_${UserID}`);
        return sortCookie ? JSON.parse(sortCookie) : { key: 'ID', direction: 'desc' };
    };
    const [sortConfig, setSortConfig] = useState(getSortConfigFromCookie());
    const [pageSize, setPageSize] = useState(getPageSizeFromCookie());
    const redirectCallback = () => {
        navigate('/'); // Redirect to the login page
    };

    useEffect(() => {
        fetchUsers(currentPage, pageSize);

    }, [currentPage, pageSize]);
    useEffect(() => {
        fetchUsers(currentPage, pageSize);

    }, [sortConfig]);



    useEffect(() => {
        setModalInstance(new window.bootstrap.Modal(document.getElementById('createUserModal')));
    }, []);

    const fetchUsers = async (page, size) => {
        try {
            const Start = Math.round((parseInt(page) * parseInt(size)) - (size - 1)).toString();
            const PageSize = size.toString();
            const usersData = await UserService.getAllUsers(redirectCallback, Start.toString(), PageSize.toString(),
                searchQuery.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setUsers(usersData);

        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };

    const fetchRoles = async () => {
        try {
            const roleData = await RoleService.GetAllRoles(redirectCallback, "1", "1000",
                "", sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setRoles(roleData);
        } catch (error) {
            console.error('Error fetching roles:', error);
        }
    };

    const fetchTeams = async () => {
        try {
            const teamData = await TeamService.GetAllTeams(redirectCallback, "1", "1000",
                "", sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
            setTeams(teamData);
        } catch (error) {
            console.error('Error fetching teams:', error);
        }
    };

    const handleCreateUserClick = async () => {
        if (users.length < AllowedUsers) {
            setCurrentUser(null);
            await fetchRoles();
            await fetchTeams();
            if (modalInstance) {
                modalInstance.show();
            }
        }
        else {
            Swal.fire(
                'Error!',
                'User creation failed: The maximum user limit has been reached. Please contact the administrator for assistance.',
                'error'
            );
        }
    };

    const handleCloseModal = () => {
        if (modalInstance) {
            modalInstance.hide();
        }
    };
    const handleSuccess = () => {
        fetchUsers(currentPage,pageSize);
    };

    

    const handleEditClick = async (user) => {
        await fetchRoles();
        await fetchTeams();
        setCurrentUser(user); // Set the user to be edited
        if (modalInstance) {
            modalInstance.show();
        }
    };

    const handleDeleteClick = async (event, user) => {
        event.stopPropagation();
        if (user.RoleName.toLowerCase() === "administrator") {
            Swal.fire(
                'Error!',
                'Administrators cannot be deleted.',
                'error'
            );
            return;
        }


        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await UserService.DeleteUsers(user.UserID); // Ensure this matches the actual function name in your service
                    await fetchUsers(currentPage,pageSize); // Fetch the updated list of users
                    Swal.fire(
                        'Deleted!',
                        'Your record has been deleted.',
                        'success'
                    );
                } catch (error) {
                    console.error('Error deleting job:', error);
                    Swal.fire(
                        'Error!',
                        'There was a problem deleting the record.',
                        'error'
                    );
                }
            }
        });


    };

    const handleResetMfaClick = async (event, email) => {
        event.stopPropagation();
        //   const email = localStorage.getItem("UserName") || localStorage.getItem("Email");
        const confirmReset = await Swal.fire({
            title: 'Are you sure?',
            text: "This will remove your MFA setup. You’ll have to reconfigure it later.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, reset it!',
            cancelButtonText: 'Cancel'
        });

        if (!confirmReset.isConfirmed) return;

        try {
            debugger;
            const res = await axios.post(`${BASE_URL}/Auth/reset-auth`, { email });
            debugger;
            if (res.data.success) {
                Swal.fire('Success', 'MFA has been reset successfully.', 'success');
                fetchUsers();
            } else {
                Swal.fire('Error', res.data.message || 'Unable to reset MFA.', 'error');
            }
        } catch (error) {
            console.error('Error resetting MFA:', error);
            Swal.fire('Error', 'Server error. Try again.', 'error');
        }
    };
    const HelpLink = localStorage.getItem('HelpLink');

    const tableRef = useRef();

    const defaultColumns = [
        "Email",
        "UserName",
        "DisplayName",
        "RoleName",
        "vc_Name",
    ];
    const defaultColumnsForSearch = [
        "Email",
        "UserName",
        "DisplayName",
        "RoleName",
        "vc_Name",

    ];
    const [searchColumns, setSearchColumns] = useState(defaultColumnsForSearch);
    const [searchOptions, setSearchOptions] = useState(defaultColumnsForSearch);
    const columnOptions = [
        { value: "Email", label: "Email" },
        { value: "UserName", label: "UserName" },
        { value: "DisplayName", label: "DisplayName" },
        { value: "RoleName", label: "RoleName" },
        { value: "vc_Name", label: "vc_Name" }

    ];
    const columnSearchOptions = [
        { value: "Email", label: "Email" },
        { value: "UserName", label: "UserName" },
        { value: "DisplayName", label: "DisplayName" },
        { value: "RoleName", label: "RoleName" },
        { value: "vc_Name", label: "vc_Name" }

    ];
    const handleSearchColumnChange = (selectedOptions) => {
        setSearchColumns(selectedOptions);

    };
    const getStoredColumns = () => {
        const storedColumns = Cookies.get(`userColumns_${CompanyID}`);
        return storedColumns ? JSON.parse(storedColumns) : columnOptions.map(option => option.value);
    };

    const [visibleColumns, setVisibleColumns] = useState(getStoredColumns());
    const handleColumnChange = (selectedOptions) => {
        setVisibleColumns(selectedOptions);

        // Save selection to cookies (valid for 1 year)
        Cookies.set(`userColumns_${CompanyID}`, JSON.stringify(selectedOptions), { expires: 365 });
    };

    const handlePageSizeChange = (event) => {
        const newPageSize = parseInt(event.target.value, 10);
        setPageSize(newPageSize);
        setPageSizeInCookie(newPageSize);
        setCurrentPage(1); // Reset to the first page
    };
    const handleSearchButtonClick = async () => {
        setCurrentPage(1); // Reset to first page


        let columnsToSearch = searchColumns.length > 0
            ? searchColumns.join(",")
            : "ALL";

        setSearchOptions(columnsToSearch);
        const query = searchQuery.toLowerCase(); // Use current searchQuery state

        const locationData = await UserService.getAllUsers(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setUsers(locationData);

    };
    const handleSort = async (key) => {

        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }

        const newConfig = { key, direction };
        setSortConfig(newConfig);
        setSortConfigInCookie(newConfig);
        setCurrentPage(1);
        //   const direction = sortConfig.key === key && sortConfig.direction === 'asc' ? 'desc' : 'asc';
        setSortConfig({ key, direction });
        const query = searchQuery.toLowerCase();
        const locationData = await UserService.getAllUsers(redirectCallback, currentPage, pageSize.toString(),
            query.toString(), sortConfig.key.toString(), sortConfig.direction.toString(), searchColumns);
        setUsers(locationData);

    };
    return (
        <div>
            <div className="row mb-3">
                <div className="col-sm-3">
                    <button className='btn btn-primary btn-sm' onClick={handleCreateUserClick}>
                        <i className="icofont-plus" aria-hidden="true"> Add New</i>
                    </button>
                </div>
                <div className="col-sm-3">
                    <strong>Allowed Users:</strong> {AllowedUsers}
                </div>
                <div className="col-sm-6" style={{ "textAlign": "right" }}>
                    <HelpSite FormName="User List" Module="26" />
                </div>
            </div>
            <div style={{ maxHeight: "80vh", overflow: "auto" }}>
                <div className="row mb-3">

                    <div className="col-sm-1">
                        <select id="pageSize" className="form-control" value={pageSize} onChange={handlePageSizeChange}>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                            <option value={500}>500</option>
                            <option value={1000}>1000</option>
                        </select>
                    </div>
                    <label style={{ paddingLeft: "0px" }} className="col-sm-2" htmlFor="pageSize">entries per page: </label>
                    <div className="col-sm-6"></div>
                    <div className="col-sm-1 d-flex align-items-center justify-content-end">
                        <span className="me-2">Search</span>


                    </div>
                    <div className="col-sm-2 d-flex justify-content-end">
                        <input
                            list="recent-searches"
                            type="text"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            className="form-control me-2"
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    handleSearchButtonClick();
                                }
                            }}
                        />

                        <button onClick={() => handleSearchButtonClick()} style={{ background: "none", border: "none" }}>
                            <img src="assets/img/resources/search.png" class="top-icon" alt="Add icon" />
                        </button>
                    </div>



                </div>
                <table className="table m-0 table-hover">
                    <thead style={{ position: "sticky", top: 0, zIndex: 2 }}>
                        <tr>
                            <th onClick={() => handleSort('Email')}> Email</th>
                            <th onClick={() => handleSort('UserName')}>User Name</th>
                            <th onClick={() => handleSort('DisplayName')}>Display Name</th>
                            <th onClick={() => handleSort('RoleName')}>Role</th>
                            <th onClick={() => handleSort('vc_Name')}>Team</th>

                            <th style={{ "textAlign": "right" }}>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {users.map((user, index) => (

                            <tr key={user.UserID} onClick={() => handleEditClick(user)} >

                                <td>{user.Email}</td>
                                <td>{user.UserName}</td>
                                <td>{user.DisplayName}</td>
                                <td>{user.RoleName}</td>
                                <td>{user.vc_Name}</td>

                                <td style={{ "textAlign": "right" }}>
                                    {(user.is_auth_enabled.toString() === "1" &&
                                        <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleResetMfaClick(event, user.Email)}>
                                            <img style={{ "width": "20px" }} src="assets/img/resources/unlock.png" class="top-icon" alt="Add icon" />
                                        </button>
                                    )}
                                    <button className="text-danger" style={{ "background": "none", "border": "none" }} onClick={(event) => handleDeleteClick(event, user)}>
                                        <i className="icofont-ui-delete" aria-hidden="true"></i>
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <CreateUser
                user={currentUser}
                onClose={handleCloseModal}
                onSuccess={handleSuccess}
                roles={roles}
                teams={teams}
            />
        </div>
    );
}

export default UserListPage;
